/* eslint-disable */
import React, { useRef,useState, useEffect } from "react";
import Container from "./Container";
import axios from "../../api";
import {
  Modal,
  Button,
  Typography,
  Box,
  Stack,
  Grid,
} from "@mui/material";
import PrintIcon from "@mui/icons-material/Print";
import ClearIcon from "@mui/icons-material/Clear";
import { useMaterialPropertiesContext } from "../../Context/MaterialPropertiesContext";
import { usePopUpContext } from "../../Context/PopupMessage";
import { useReactToPrint } from "react-to-print";
const MaterialPropertiesModal = (props) => {
  const {  prsMdValue } = useMaterialPropertiesContext();
 
  const { setPopupMessage, setLoading } = usePopUpContext();
  const componentRef = useRef();
  useEffect(() => {
    setLoading(true)


    axios.post("/matproperties", prsMdValue).then((res) => {
      setLoading(false)
      if(res.data.output.rtnSts==2){
        setPopupMessage({ state: true, type: "error", message:res.data.output.msg })
        props.onClose()
      }else{
    
        setMaterialPropertiesData(res.data.output);
        setChemicalAnalysisRows(res.data.output.chmTbl)
        setMechanicalArray(res.data.output.mechTbl)
      }
      
    })
    .catch((e) => {
      console.log(e);
       setLoading(false)
      //  setPopupMessage({ state: true, type: "error", message: "Something went wrong please try again." })
    });
    
  }, []);

  const [materialPropertiesData, setMaterialPropertiesData] = useState([]);
  const [chemicalAnalysisRows, setChemicalAnalysisRows] = useState([ ]);
  const [ MechanicalArray, setMechanicalArray] = useState([ ]);
  const handleAfterPrint = React.useCallback(() => {
    props.onClose()
  }, []);
  const [chemicalAnalysisColumns, setChemicalAnalysisColumns] = useState([]);
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
    // pageStyle:'@page { size: auto; margin: 0mm; } @media print { body { -webkit-print-color-adjust: exact;font-family: Courrier New, monospace; padding: 40px !important; } }',
    documentTitle: `Material_Property_${new Date().toJSON().slice(0,10)}`,
    // onBeforeGetContent: handleOnBeforeGetContent,
    onAfterPrint:handleAfterPrint,
    removeAfterPrint: true
  });
  
  return (
    <Modal open={props.open} onClose={props.onClose}>
      

      <Container
        position="absolute"
        top="10%"
        left="15.5%"
      
        sx={{
          overFlow: "auto",
          display: "flex",
          flex: 1,
          flexDirection: "column",
          background: "white",
          height: "auto",
          width: "700px",
        }}
        className="ixPopupLayout"
      >
         <Stack direction="column" spacing={1} padding={1}>
       
       <Stack className="ixPopupHeader" direction="row" justifyContent="space-between">
       <Box
        sx={{
        
          fontSize: '16px',
          fontWeight: '700',
        }}
      >
       Material Properties
      </Box>
            <Button sx={{  displayPrint: 'none'}} onClick={props.onClose} styletype="icon"><ClearIcon /></Button>
          </Stack>
          <div     ref={componentRef}  >
          <Box
        sx={{
          display: 'none',
          displayPrint: 'block',
          m: 1,
          fontSize: '16pt',
          fontWeight: '700',
          textAlign:"center"
        }}
      >
       Material Properties
      </Box>
         
            <Stack   direction="row"  spacing={4} >
            <Grid container sx={{ padding: "10px" }}  spacing={1} direction="row" >

              <Grid  className="coilDescriptionHeader" item xs={2}  > Location </Grid>
             
              <Grid className="coilDescriptionHeader" item xs={10}>: {materialPropertiesData.brhNm}</Grid>
              <Grid item xs={2} >Mill</Grid>
             
              <Grid item xs={4}>: {materialPropertiesData.cusNm}</Grid>
              <Grid item xs={2} >End-user</Grid>
           
              <Grid item xs={4}>: {materialPropertiesData.eusrNm}</Grid>
              <Grid item xs={2} >Mill Order No.</Grid>
             
             <Grid item xs={4}>: {materialPropertiesData.cusPoNo}</Grid>
             <Grid item xs={2} >End-User PO No.</Grid>
          
             <Grid item xs={4}>: {materialPropertiesData.eusrPoNo}
             </Grid> <Grid item xs={2} >Part Number</Grid>
             
             <Grid item xs={4}>: {materialPropertiesData.partNo}</Grid>
             <Grid item xs={2} >Material Type</Grid>
          
             <Grid item xs={4}>: {materialPropertiesData.prg}</Grid> 
             <Grid item xs={2} >Product</Grid>
             
             <Grid item xs={4}>: {materialPropertiesData.prdStr}</Grid>
             <Grid item xs={2} >Specifications</Grid>
          
             <Grid item xs={4}>: {materialPropertiesData.grdDesc}</Grid>
             <Grid item xs={2} >Mill Coil ID</Grid>
          
          <Grid item xs={4}>: {materialPropertiesData.cusTagNo}</Grid> 
           <Grid item xs={2} >Proc. Coil ID</Grid>
          
          <Grid item xs={4}>: {materialPropertiesData.procrTagNo}</Grid>
          <Grid item xs={2} >Weight</Grid>
          
          <Grid item xs={4}>: {materialPropertiesData.wgtStr}</Grid> 
           <Grid item xs={2} >Pieces</Grid>
          
          <Grid item xs={4}>: {materialPropertiesData.pcsStr}</Grid> 
           <Grid item xs={2} >Receive Date</Grid>
          
          <Grid item xs={4}>: {materialPropertiesData.rcvDts}</Grid>
            <Grid item xs={2} >Update Date</Grid>
          
          <Grid item xs={4}>: {materialPropertiesData.origRefDts}</Grid> 
           {prsMdValue.prsMd === "I" ?
           
           <><Grid item xs={2} >Material Status</Grid>
          
          <Grid item xs={4}>: {materialPropertiesData.matStsDesc}</Grid>  
          <Grid item xs={2} >Reservation Sts</Grid>
          
        
          <Grid item xs={4}>: {materialPropertiesData.invtTypDesc}</Grid> 
          </>
          :
          
          <><Grid item xs={2} >Ship Date</Grid>
          
          <Grid item xs={4}>: {materialPropertiesData.shpDts}</Grid>  
          <Grid item xs={2} >B/L</Grid>
          
        
          <Grid item xs={4}>: {materialPropertiesData.tollBlNo}</Grid> 
          </>
          
          
          }
           <Grid item xs={2} >Mill-Heat</Grid>
          
          <Grid item xs={4}>: {materialPropertiesData.milHetStr}</Grid>
          <Grid item xs={12} > 
          <Box sx={{paddingTop:0, height:"1px",border: "1px solid #6D92A5" }} >
          
          </Box></Grid>
          <Grid item xs={2} >Chemical Analysis</Grid>
          
          <Grid item xs={10}>
            {materialPropertiesData.chmNbrRec > 0? <Grid container >
        {  chemicalAnalysisRows.map((row, key) => 
        <>  
                 <Grid item xs={4} >{row.chmEl + " = " + row.chmStr}</Grid>
              </>

        )}
        
        </Grid>:": Not Available"}
           
          
         </Grid>
          
         <Grid item xs={12} > 
          <Box sx={{paddingTop:0, height:"1px",border: "1px solid #6D92A5" }} >
          
          </Box></Grid>

          <Grid item xs={2} >Mechanical Properties</Grid>
          
          <Grid item  xs={10} >
          {materialPropertiesData.mechNbrRec > 0? 
            <Grid container  >
        {  MechanicalArray.map((row, key) => 
                materialPropertiesData.mechNbrRec>key?
                 <Grid item xs={4} >{row.specAbbr + " = " + row.specStr}</Grid>:null
            

        )}
        
        </Grid>:": Not Available"}
          
         </Grid>

              
            </Grid>
          </Stack>
          </div>
          <Stack sx={{padding: "10px"}} direction="row" justifyContent="flex-end" alignItems="center">
            <Button onClick={handlePrint} className="ixButtonPopup" >
              <PrintIcon />
              <Typography>Print</Typography>
            </Button></Stack>
      
            </Stack>
      </Container>
      
    </Modal>
  );
};
export default MaterialPropertiesModal;
